// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import vueresource from 'vue-resource'
import 'swiper/swiper-bundle.css';
import VueAnalytics from 'vue-analytics'
import VueHead from 'vue-head'

require('@/styles/main.scss');

Vue.use(vueresource)
Vue.use(VueHead)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

Vue.use(VueAnalytics, {
  id: 'UA-30119836-2',
  router
})
